import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LogoutContent from "../../components/Authentication/LogoutContent";
import { API_ENDPOINTS } from "../../config/api";
import axios from "axios";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await axios.post(API_ENDPOINTS.AUTH.LOGOUT);
        // Clear any local storage items if needed
        localStorage.removeItem('token');
        localStorage.removeItem('userData');
        console.log("you have successfully Logged Out");
        navigate("/", { replace: true, state: { shouldRefresh: true } });
      } catch (error) {
        console.error('Logout failed:', error);
        // Even if the API call fails, we should still redirect to home
        navigate("/", { replace: true, state: { shouldRefresh: true } });
      }
    };

    handleLogout();
  }, [navigate]);

  return (
    <>
    </>
  );
};

export default Logout;
